// lib/format.js
/**
 * Fonctions de formatage réutilisables
 */

/**
 * Formate un montant en XOF
 */
export function formatMoney(amount, currency = 'XOF') {
  const value = Number(amount || 0)
  const formatted = value.toLocaleString('fr-FR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return `${formatted} ${currency}`
}

/**
 * Formate une date ISO en français
 */
export function formatDate(isoDate, options = {}) {
  if (!isoDate) return '—'

  const defaultOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...options,
  }

  return new Date(isoDate).toLocaleDateString('fr-FR', defaultOptions)
}

/**
 * Formate une date en YYYY-MM-DD
 */
export function toYYYYMMDD(date = new Date()) {
  return date.toISOString().slice(0, 10)
}

/**
 * Formate un numéro de téléphone
 */
export function formatPhone(phone) {
  if (!phone) return ''
  const cleaned = phone.replace(/\D/g, '')
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5')
  }
  return phone
}

/**
 * Tronque un texte avec ellipsis
 */
export function truncate(text, maxLength = 50) {
  if (!text || text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

/**
 * Convertit un identifiant de période en { from, to } au format YYYY-MM-DD.
 * Supporte : today, current_week, current_month, last_30, last_90
 * Retourne {} si la période n'est pas reconnue.
 */
export function resolvePeriodFilter(period) {
  if (!period) return {}
  const today = new Date()
  const fmt = (d) => d.toISOString().slice(0, 10)
  const todayStr = fmt(today)

  if (period === 'today') {
    return { from: todayStr, to: todayStr }
  }
  if (period === 'current_week') {
    const start = new Date(today)
    start.setDate(today.getDate() - today.getDay())
    return { from: fmt(start), to: todayStr }
  }
  if (period === 'current_month') {
    const start = new Date(today.getFullYear(), today.getMonth(), 1)
    return { from: fmt(start), to: todayStr }
  }
  if (period === 'last_30') {
    const start = new Date(today)
    start.setDate(today.getDate() - 30)
    return { from: fmt(start), to: todayStr }
  }
  if (period === 'last_90') {
    const start = new Date(today)
    start.setDate(today.getDate() - 90)
    return { from: fmt(start), to: todayStr }
  }
  return {}
}

/**
 * Génère les initiales d'un nom
 */
export function getInitials(name) {
  if (!name) return 'U'
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return 'U'
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase()
}
